var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 59,
    viewBox: "0 0 78 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8317 42.1948V53.0991C69.8317 55.7757 67.6619 57.9455 64.9854 57.9455H6.82876C4.15223 57.9455 1.98242 55.7757 1.98242 53.0991V19.1745C1.98242 16.4979 4.15223 14.3281 6.82876 14.3281H64.9854C67.6619 14.3281 69.8317 16.4979 69.8317 19.1745V37.3483",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73242 9.48098C7.50042 8.55419 8.61287 7.91027 9.90299 7.76008L67.6691 1.03299C70.3277 0.723403 72.734 2.62755 73.0436 5.28627L76.9678 38.9832C77.2774 41.6417 75.3733 44.0481 72.7146 44.3576L69.8314 44.6933",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25488 43.4052H18.9477",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25488 49.4644H33.4867",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.793 43.4052H33.4856",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3301 43.4052H48.0228",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8682 43.4052H62.5608",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9477 37.347H11.6781C10.3399 37.347 9.25488 36.2622 9.25488 34.9238V30.0774C9.25488 28.7392 10.3397 27.6542 11.6781 27.6542H18.9477C20.286 27.6542 21.371 28.739 21.371 30.0774V34.9238C21.3708 36.2622 20.286 37.347 18.9477 37.347Z",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0967 32.5018H16.5199",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8496 33.7127C59.6668 32.0701 60.1379 30.2227 60.1379 28.2605C60.1379 26.2982 59.6668 24.4506 58.8496 22.8082",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5039 31.524C54.9955 30.5391 55.2909 29.4375 55.2909 28.2597C55.2909 27.0819 54.9955 25.9803 54.5039 24.9954",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1807 29.3471C50.3472 29.0203 50.449 28.6552 50.449 28.2621C50.449 27.8689 50.3472 27.5039 50.1807 27.1771",
    stroke: "#00BFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarte);
export default __webpack_public_path__ + "static/media/carte.1d7a6036a2e3ce393fbd3947ec13b241.svg";
export { ForwardRef as ReactComponent };